export default __webpack_public_path__ + "static/media/gothenburg_s3.38a6c731.png";